import { Cell } from "../components/Cell";
import { COLUMNS, FOLLOW_UP_GROUPS } from "../model/materielConstants";
import { formatFollowUpPatient } from "../model/followUpRules";
import { followUpCellStyle, followUpGroupHeaderStyle, followUpHeaderStyle, followUpPinnedHeaderStyle } from "../styles/followUpTableStyles";
import { headerSelectButtonStyle, inactivePatientBadgeStyle, patientEditButtonStyle } from "../styles/materielStyles";

function FollowUpGridRow({ row, columnColors, selectedColumn, onEditPatient, onPatch }) {
    return (
        <tr
            style={{
                background: row.notInvoiced ? "#fee2e2" : "white",
            }}
        >
            {COLUMNS.map((column, columnIndex) => (
                <td key={column.key} style={followUpCellStyle(row, columnIndex, columnColors, selectedColumn)}>
                    {column.key === "patient" ? (
                        <button type="button" onClick={() => onEditPatient(row)} title="Modifier le patient" style={patientEditButtonStyle}>
                            <span>
                                <span style={{ display: "block" }}>{formatFollowUpPatient(row) || "Patient à renseigner"}</span>
                                {row.inactive && <small style={inactivePatientBadgeStyle}>Patient inactif</small>}
                            </span>
                            <span aria-hidden="true" style={{ fontSize: "15px" }}>✎</span>
                        </button>
                    ) : (
                        <Cell
                            row={row}
                            column={column}
                            checkboxAlign="center"
                            onChange={value => onPatch(
                                row.id,
                                value && typeof value === "object" ? value : { [column.key]: value }
                            )}
                        />
                    )}
                </td>
            ))}
        </tr>
    );
}

// Format tableau : patient et case « CLT PHARMACIE » épinglés à gauche, colonnes regroupées par thème ; cliquer
// un en-tête sélectionne la colonne pour lui donner une couleur.
export function FollowUpGrid({ rows, colors, onEditPatient, onPatch }) {
    const { columnColors, selectedColumn, setSelectedColumn } = colors;
    return (
        <table style={{ borderCollapse: "collapse", minWidth: "3300px", width: "100%" }}>
            <thead>
                <tr>
                    {COLUMNS.slice(0, 2).map((column, columnIndex) => (
                        <th
                            key={column.key}
                            rowSpan={2}
                            style={followUpPinnedHeaderStyle(column, columnIndex, columnColors, selectedColumn)}
                        >
                            <button type="button" onClick={() => setSelectedColumn(column.key)} style={headerSelectButtonStyle}>
                                {column.label}
                            </button>
                        </th>
                    ))}
                    {FOLLOW_UP_GROUPS.map(group => {
                        const visibleColumns = group.columns.filter(columnKey => !["cltPharmacie", "patient"].includes(columnKey));
                        return visibleColumns.length > 0 ? (
                            <th key={group.key} colSpan={visibleColumns.length} style={followUpGroupHeaderStyle(group)}>
                                {group.label}
                            </th>
                        ) : null;
                    })}
                </tr>
                <tr>
                    {COLUMNS.slice(2).map((column, columnIndex) => (
                        <th key={column.key} style={followUpHeaderStyle(column, columnIndex + 2, columnColors, selectedColumn)}>
                            <button type="button" onClick={() => setSelectedColumn(column.key)} style={headerSelectButtonStyle}>
                                {column.label}
                            </button>
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {rows.map(row => (
                    <FollowUpGridRow
                        key={row.id}
                        row={row}
                        columnColors={columnColors}
                        selectedColumn={selectedColumn}
                        onEditPatient={onEditPatient}
                        onPatch={onPatch}
                    />
                ))}
            </tbody>
        </table>
    );
}
